import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {SmsEngagementModalGraphic} from './assets';

import styles from './tooltip-modal-styles.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function SmsMessageEngagementModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<SmsEngagementModalGraphic />}
            bodyComponent={
                <div className={styles.container}>
                    <ModalHeader>SMS engagement</ModalHeader>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            Nutshell automatically tracks when your messages are delivered, and
                            responded to.
                        </ModalBody>
                    </SpacerGroup>
                    <BulletedList
                        bullets={[
                            <ModalBody key='1'>
                                <b>Messages sent</b> shows the total number of messages that were
                                successfully delivered
                            </ModalBody>,
                            <ModalBody key='2'>
                                <b>Response rate</b> represents the percentage of responses from
                                your recipients
                            </ModalBody>,
                        ]}
                    />
                </div>
            }
        />
    );
}
